module.exports = __webpack_public_path__ + "media/application/images/icons/close-b7ff95ec5dd102bc730857cff4c90aa5.svg";